<template>
  <div>1</div>
</template>

<script>
export default {
  name: 'homePageTab'
}
</script>

<style scoped>

</style>
